import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import styles from './Delimiter.css';
export const Delimiter = memo(function Delimiter({ delimiter = ':' }) {
    return (_jsx("div", Object.assign({ className: styles.delimiter }, { children: delimiter }), void 0));
});
